module.exports = __webpack_public_path__ + "static/scale-model-of-simmons-hippo-outpost-in-dallas-texas-edc043adc59c7c34b97b76b19d9d7f94.png";